import React, { useMemo } from 'react';
import classNames from 'classnames';
import _ from 'underscore';

import { ResponsiveSize } from '@bingads-webui-campaign-react/pmax-overview-responsive-utils';

import { MetricPickerItem } from './metric-picker-item';
import { MetricPickerShimmer } from './metric-picker-shimmer';
import { useStyles } from '../styles/metric-picker';

export interface IMetricPickerProps {
  selectedMetricIndexes: number[];
  visibleMetrics: string[];
  allMetrics: Array<{
    key: string,
    displayName: string,
    total: string,
  }>;
  isComparisonEnabled: boolean;
  responsiveSize: ResponsiveSize;
  i18n: any;
  hideCurrency: boolean;
  onMetricUpdate: (selectedMetricIndexes: number[], visibleMetrics: string[]) => void;
}

export function MetricPicker(props: IMetricPickerProps) {
  const {
    visibleMetrics,
    selectedMetricIndexes,
    allMetrics = [],
    isComparisonEnabled = false,
    responsiveSize,
    i18n,
    hideCurrency,
    onMetricUpdate,
  } = props;

  const dropdownMetrics = allMetrics.filter(metric => !visibleMetrics.includes(metric.key));
  const classes = useStyles();

  const items = useMemo(() => visibleMetrics.map((metric, index) => {
    const isSelected = selectedMetricIndexes.includes(index);
    const onMetricToggle = () => {
      const newSelectedMetricIndexes = isSelected
        ? selectedMetricIndexes.filter(i => i !== index)
        : [...selectedMetricIndexes, index].sort((a, b) => a - b);
      onMetricUpdate(newSelectedMetricIndexes, visibleMetrics);
    };
    const onMetricDropdownSelect = (key: string) => {
      const newVisibleMetrics = [...visibleMetrics];
      newVisibleMetrics[index] = key;
      onMetricUpdate(selectedMetricIndexes, newVisibleMetrics);
    };
    const displayName = allMetrics.find(m => m.key === metric)?.displayName;
    const total = allMetrics.find(m => m.key === metric)?.total;

    return (
      <MetricPickerItem
        key={metric}
        index={index}
        isSelected={isSelected}
        displayName={displayName}
        total={total}
        i18n={i18n}
        hideCurrency={hideCurrency}
        dropdownMetrics={dropdownMetrics}
        isComparisonEnabled={isComparisonEnabled}
        onMetricToggle={onMetricToggle}
        onMetricDropdownSelect={onMetricDropdownSelect}
        responsiveSize={responsiveSize}
      />
    );
  }), [allMetrics, dropdownMetrics, isComparisonEnabled, onMetricUpdate, selectedMetricIndexes, visibleMetrics, responsiveSize]);

  if (_.isEmpty(allMetrics)) {
    return <MetricPickerShimmer />;
  }

  return (
    <div className={classNames('ba-performance-card-metric-picker', classes.metricPicker)}>
      {items}
    </div>
  );
}

